import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-Login',
  templateUrl: './Login.component.html'
})
export class LoginComponent implements OnInit {

  constructor() { }


  ngOnInit() {
  }
  
}
